import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Ag1LinkComponent } from '../ag1-link/ag1-link.component';
import { Ag1LoaderComponent } from '../ag1-loader/ag1-loader.component';

export type TQueueItemState = 'loading' | 'error' | 'success' | 'queued';

export interface IQueueItemAction {
  label: string;
}

export interface IQueueItemLeadingIcon {
  iconUrl: string;
  color: string;
}

export interface IQueueItem {
  id: string; // (Required) The unique identifier for the queue item e.g. document's id.
  title: string; // (Required) The title of the queue item e.g. a document's name.
  subTitle?: string; // (Optional) Additional information about the queue item e.g. a document's type.
  leadingIcon?: IQueueItemLeadingIcon; // (Optional) The icon to display in the leading position of the queue item.
  state: TQueueItemState; // (Required) The state of the queue item e.g. document's status.
  action?: IQueueItemAction; // (Optional) The action to be performed when the queue item button is clicked e.g. view document.
}

@Component({
  selector: 'ag1-queue-item',
  templateUrl: './ag1-queue-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, Ag1LinkComponent, Ag1LoaderComponent],
})
export class Ag1QueueItemComponent {
  /** (Required) The queue item to display. */
  @Input() queueItem: IQueueItem;

  /** (Optional) The action to be performed when the queue item button is clicked. */
  @Output() itemClickEvent: EventEmitter<IQueueItem> =
    new EventEmitter<IQueueItem>();

  constructor() {}

  getStateColor(state: TQueueItemState): string {
    switch (state) {
      case 'error':
        return 'text-red-700';
      case 'success':
        return 'text-green-700';
      default:
        return 'text-french-blue-600';
    }
  }

  getStateIcon(state: TQueueItemState): string {
    switch (state) {
      case 'error':
        return '/assets/icons/general/system-feedback-warning.svg';
      case 'success':
        return '/assets/icons/general/system-feedback-success.svg';
      default:
        return '/assets/icons/general/system-feedback-clock.svg';
    }
  }

  onItemClick(item: IQueueItem): void {
    this.itemClickEvent.emit(item);
  }
}
